module.exports = __webpack_public_path__ + "img/fingers.2d1ac8bf.svg";